const authActionsTypes = {
  AUTH_REQUEST: 'AUTH_REQUEST',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_FAILURE: 'AUTH_FAILURE',
  AUTH_SIGNOUT: 'AUTH_SIGNOUT',
  SAVE_USER_DATA: 'SAVE_USER_DATA',
};

export default authActionsTypes;
